export default __webpack_public_path__ + "static/media/teamDark.4b55e403.svg";